export default __webpack_public_path__ + "static/media/ic_arrow_to_top.34179e06.svg";